/* eslint-disable import/prefer-default-export */
export class BackMappings {
  static TARJETA = 'miTarjeta';

  static AHORROS = 'misAhorros';

  static ORO = 'oro';

  static TARJETA_CTA_ORO = 'tarjeta_oro_cta';

  static TARJETA_MENU_ORO = 'tarjeta_oro_menu';

  static PUNTOS_TRAVEL = 'misPuntosTravel';

  static SALDO = 'miSaldoEuros';

  static MISDATOS = 'misdatos';

  static COMPRAS = 'misCompras';

  static VALES = 'cupones';

  static REVISTA = 'revista';

  // bot
  static CAMBIO_MAIL = 'misdatos/change/mail';

  static CAMBIO_PASS = 'misdatos/change/pass';

  static BAJA_DIGITAL = 'misdatos/baja/digital';

  static TARJETAS_BOT = 'miTarjeta/bot';

  static GO_TO_LOGIN = 99;

  static GO_TO_RELOGIN = 100;
}
